import { isEmpty } from 'lodash-es';
import { COMMON } from '../strings/common';

export const genericErrorMessage = 'Something went wrong !';
export const API_MESSAGE_SUCCESS = 'success';

export const API_CONSTANTS = {
	pincode: (pincode) => `api/pincode/${pincode}`,
	pincodeV2: `/api/fury/relay/admin/equity/ccm/address/get/v2`,
	summary: '/api/user/account/summary',
};

export const handleApi = (res) => {
	if (
		res.pfwstatus_code !== 200 ||
		!res.pfwresponse ||
		isEmpty(res.pfwresponse)
	) {
		throw {
			message: res.pfwmessage || genericErrorMessage,
			statusCode: res.pfwstatus_code,
		};
	}
	const { result, status_code: status } = res.pfwresponse;
	if (status === 200) {
		return result;
	} else {
		throw {
			message: result.error || result.message || genericErrorMessage,
			statusCode: status,
		};
	}
};

export const handleOdinApi = (res = {}) => {
  if (res.message === "Network Error") {
    throw new Error(COMMON.networkErrorMessage);
  }
  const { status, message = "" } = res;
  if (status === "error") {
    throw new Error(message || genericErrorMessage);
  } else if (status === "success" || status === true) {
    return res;
  } else {
    throw new Error(message || genericErrorMessage);
  }
};



export const getPinCodeData = async (Api, pincode) => {
	const res = await Api.get(API_CONSTANTS.pincode(pincode));
	return handleApi(res);
};

export const getCMMPincodeData = async (Api, pincode) => {
	const res = await Api.get(API_CONSTANTS.pincodeV2, { pincode });
	return handleApi(res);
};

export async function getAccountSummary(Api, params = {}, token) {
	if (isEmpty(params)) {
		params = {
			campaign: ['user_campaign'],
			kyc: ['kyc'],
			user: ['user'],
			nps: ['nps_user'],
			partner: ['partner'],
			bank_list: ['bank_list'],
			referral: ['subbroker', 'p2p'],
			equity: ['subscription_status'],
		};
	}
	const response = await Api.post(API_CONSTANTS.summary, params, {}, token);
	return handleApi(response);
}

export const fetch_equity_status_data = async (Api, token = '') => {
	const options = {
		equity: ['subscription_status'],
	};
	const url = API_CONSTANTS.summary;
	const summaryData = await Api.post(url, options, {}, token);
	return handleApi(summaryData);
};

export const handleSessionLessApi = (res) => {
	const defaultErrorMessage = COMMON.genericErrorMessage;
	if (res.message === 'Network Error') {
		throw new Error(COMMON.networkErrorMessage);
	}
	if (
		res.pfwstatus_code !== 200 ||
		!res.pfwresponse ||
		isEmpty(res.pfwresponse)
	) {
		throw new Error(res?.pfwmessage || defaultErrorMessage);
	}

	const { result, status_code: status } = res.pfwresponse;
	if (status === 200) {
		return result;
	} else {
		const data = {
			message: result.message || result.error || defaultErrorMessage,
			statusCode: status,
			result,
		};
		throw data;
	}
};
